export const TAGS = {
  CRYPTO_PAYOUTS_LIST: 'cryptoPayoutsList',
};
